module.exports = __webpack_public_path__ + "img/thumbnail-image-2.0a577aa6.jpg";